/**
 * Penentuan alamat dasar API — MURNI.
 *
 * Dipisahkan dari `src/config.ts` karena berkas itu menyentuh `import.meta.env`, yang hanya ada
 * di dalam Vite; mengimpornya dari uji Node akan meledak sebelum satu pun assertion berjalan.
 * Seluruh keputusan ada di sini supaya ia dapat diuji, dan `config.ts` tinggal memanggilnya.
 *
 * # Mengapa `??` saja tidak cukup
 *
 * Bentuk sebelumnya adalah `import.meta.env.VITE_WORKFORCE_API_URL ?? 'http://localhost:3300'`.
 * `??` HANYA menangkap `undefined`/`null`. Build image yang tidak mengisi `--build-arg`
 * menghasilkan **string kosong**, bukan nilai yang hilang — jadi `??` melewatkannya apa adanya
 * dan `apiBaseUrl` menjadi `''`.
 *
 * Akibatnya di `api/client.ts`: `fetch(`${config.apiBaseUrl}${path}`)` berubah menjadi permintaan
 * RELATIF ke origin web itu sendiri. Permintaan itu ditangkap SPA fallback nginx dan dijawab
 * `index.html`, sehingga aplikasi menerima HTML saat mengharapkan JSON. Tidak ada yang gagal
 * dengan berisik: build hijau, health check hijau, dan kerusakannya baru muncul di tangan
 * petugas lapangan.
 */

/** Dipakai HANYA saat variabel memang tidak diisi — yaitu `pnpm dev` di mesin pengembang. */
export const DEV_API_BASE_URL = 'http://localhost:3300';

/**
 * Nilai kosong, spasi, atau hilang diperlakukan SAMA: seolah tidak diisi.
 *
 * Ini memulihkan maksud asli `??` alih-alih membiarkan string kosong menyamar sebagai nilai yang
 * sah. Ia sengaja TIDAK melempar: melempar saat modul dimuat akan memutih-layarkan aplikasi di
 * lapangan, sedangkan di sisi build sudah ada penjaga yang menghentikan image tanpa nilai
 * (`apps/workforce-web/Dockerfile`). Yang perlu dijamin di sini hanyalah nilai yang keluar tidak
 * pernah berbentuk yang membuat URL berubah menjadi relatif.
 *
 * Garis miring di ekor dibuang karena `client.ts` merangkai `${apiBaseUrl}${path}` dengan `path`
 * yang sudah diawali `/` — tanpa ini, `https://host/` menghasilkan `https://host//api/me`.
 */
export function resolveApiBaseUrl(
  raw: string | undefined | null,
  /**
   * Bawaan pengembangan untuk alamat SELAIN Workforce API (HBS API, Supabase). Sengaja wajib
   * disebut pemanggil alih-alih ditebak di sini: bawaan yang salah diam-diam menunjuk layanan
   * yang keliru, dan galatnya muncul jauh dari sini.
   */
  fallback: string = DEV_API_BASE_URL,
): string {
  const trimmed = (raw ?? '').trim();
  const value = trimmed.length > 0 ? trimmed : fallback;
  return value.endsWith('/') ? value.replace(/\/+$/, '') : value;
}
